<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/project/form' }">
        <a-button type="primary" icon="plus">
          创建项目信息
        </a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select" style="margin-bottom:50px;">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.title"
              placeholder="请输入项目名称"
              enter-button
              @search="getLists()"
            />
          </div>
        </standard-form-row>
      </a-form>
    </a-card>
    <a-list
      :loading="loading"
      :data-source="list"
      :grid="{ gutter: 24, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }"
      :pagination="pagination"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card class="ant-pro-pages-list-projects-card" hoverable>
          <viewer slot="cover" class="cover-pic">
            <img src="../../../../public/Openbanner2.png" style="object-fit: cover;" v-if="item.image == null" />
            <img :src="globalUrl + item.image" :key="item.name" style="object-fit: cover;" v-if="item.image !== null" />
          </viewer>
          <a-card-meta :title="item.name">
            <template slot="description" >
              <a :href="item.web_url" target="_blank" style="white-space:nowrap;">{{ item.web_url? item.web_url : "无链接" }}</a>
            </template>
          </a-card-meta>
          <div class="cardItemContent" style="margin-top:15px;">
            <p>类别：<b style="color:red">{{ item.typeid === 2 ? '孵化筹备期' : '孵化期项目' }}</b>  </p>
            <p>创建时间：{{ moment(item.created_at).fromNow() }}</p>
            <p>上次修改：{{ moment(item.updated_at).fromNow() }}</p>
            <p>排序： <span style="color:red;font-weight:700">{{ item.sort }}</span></p>
          </div>
          <template slot="actions">
            <router-link v-action:update :to="'/project/form/' + item.id">
              <a-icon type="edit" />
            </router-link>
            <a-tooltip title="删除" v-action:delete>
              <a-popconfirm
                title="确定要删除该项目吗？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="handleOnDelete(item.id)"
              >
                <a-icon type="delete" />
              </a-popconfirm>
            </a-tooltip>
          </template>
        </a-card>
      </a-list-item>
    </a-list>
  </page-header-wrapper>
</template>

<script>
import { list, select, card } from '@/mixins' // 引入
import { TagSelect } from '@/components'

const TagSelectOption = TagSelect.Option
const apiList = {
    getList: '/opensource',
    changeState: '/opensource/finds/',
    delete: 'opensource/',
    selectList: '/info/categories/select'
}

export default {
    name: 'projectList',
    mixins: [list, card, select], // 使用mixins
    components: {
        TagSelect,
        TagSelectOption
    },
    data () {
        return {
            apiList,
            selectLoad: false
        }
    },
    mounted () {
      this.getLists()
    },
    methods: {
    }
}
</script>
